import React from "react";
import { Helmet } from "react-helmet-async";
import { SITE_URL } from "../../lib/booking";

export const Seo = ({
    title,
    description,
    canonical,
    keywords,
    jsonLd,
    noindex = false,
    ogImage = `${SITE_URL}/og-image.jpg`,
}) => {
    const canonicalUrl = canonical?.startsWith("http")
        ? canonical
        : `${SITE_URL}${canonical || ""}`;
    const schemas = Array.isArray(jsonLd) ? jsonLd : jsonLd ? [jsonLd] : [];

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            {noindex ? (
                <meta name="robots" content="noindex, nofollow" />
            ) : (
                <meta
                    name="robots"
                    content="index, follow, max-image-preview:large"
                />
            )}
            <link rel="canonical" href={canonicalUrl} />

            <meta property="og:type" content="website" />
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonicalUrl} />
            <meta property="og:image" content={ogImage} />
            <meta property="og:locale" content="fr_CH" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={title} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={ogImage} />

            {schemas.map((schema, i) => (
                <script type="application/ld+json" key={i}>
                    {JSON.stringify(schema)}
                </script>
            ))}
        </Helmet>
    );
};
